import { sendEvent } from '../../../configs/firebase'

type ChatBaseParams = {
  appointmentId?: string
  doctorId?: string
}

const chatAnalytics = {
  trackScreenViewed(params: ChatBaseParams = {}): void {
    sendEvent('chat_screen_viewed', params)
  },

  trackMessageSent(params: ChatBaseParams = {}): void {
    sendEvent('chat_message_sent', params)
  },

  trackMessageReceived(params: ChatBaseParams = {}): void {
    sendEvent('chat_message_received', params)
  },

  trackMessageFailed(params: ChatBaseParams & { reason?: string } = {}): void {
    sendEvent('chat_message_failed', {
      ...params,
      reason: params.reason ?? 'unknown',
    })
  },

  trackHistoryLoaded(
    params: ChatBaseParams & { messagesCount?: number } = {}
  ): void {
    sendEvent('chat_history_loaded', {
      ...params,
      messagesCount: params.messagesCount ?? 0,
    })
  },

  /**
   * Fase 2 (shadow read): divergência entre o histórico do SDK e o da API.
   *
   * Só contagem e, no máximo, o primeiro `messageSid` de cada lado. Corpo de
   * mensagem, autor, nome de anexo e identidade são dado clínico e **não**
   * entram em telemetria.
   */
  trackHistoryShadowRead(
    params: ChatBaseParams & {
      status: 'match' | 'divergent' | 'empty-history' | 'failed'
      missingInApiCount?: number
      extraInApiCount?: number
      sdkCount?: number
      apiCount?: number
      pagesFetched?: number
      truncated?: boolean
      firstMissingSid?: string
      firstExtraSid?: string
      /** Preenchidos em `failed`: sem eles não dá para agrupar a causa. */
      errorStatus?: number
      errorCode?: string
    }
  ): void {
    sendEvent('chat_history_shadow_read', params)
  },
}

export default chatAnalytics
